export const iconFontAwesomeMoneyGg = (
	<i className="fa-solid fa-gg"></i>
);
